import { signal } from '@angular/core';

export const isBluetoothSupported = signal('navigator' in window && 'bluetooth' in navigator);
